import React from 'react';

import type { Section } from '../../../../models/index';
import SwitchesWithTitle from '../../../Widgets/SwitchesWithTitle';
import type { SwitchObject } from '../../../../models/Types';
import { ADDITIONAL_RULES } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function AdditionalRules({ section, setSectionValues }: Props): JSX.Element {
  function onPropertyUsageToggle(): void {
    toggleSwitch(ADDITIONAL_RULES.FIELD_NAME.PROPERTY_USAGE);
  }

  function onResidentActivitiesToggle(): void {
    toggleSwitch(ADDITIONAL_RULES.FIELD_NAME.RESIDENT_ACTIVITIES);
  }

  function onKeysToggle(): void {
    toggleSwitch(ADDITIONAL_RULES.FIELD_NAME.KEYS);
  }

  function onCustomToggle(): void {
    toggleSwitch(ADDITIONAL_RULES.FIELD_NAME.CUSTOM);
  }

  function toggleSwitch(key: string): void {
    setSectionValues({
      [key]: !section.getFieldValue(key),
    });
  }

  const rules: Array<SwitchObject> = [
    {
      text: 'Property usage',
      onClick: onPropertyUsageToggle,
      toggled: section.getFieldValue(ADDITIONAL_RULES.FIELD_NAME.PROPERTY_USAGE),
      disabled: section.isFieldDisabled(ADDITIONAL_RULES.FIELD_NAME.PROPERTY_USAGE),
    },
    {
      text: 'Resident activities',
      onClick: onResidentActivitiesToggle,
      toggled: section.getFieldValue(ADDITIONAL_RULES.FIELD_NAME.RESIDENT_ACTIVITIES),
      disabled: section.isFieldDisabled(ADDITIONAL_RULES.FIELD_NAME.RESIDENT_ACTIVITIES),
    },
    {
      text: 'Keys',
      onClick: onKeysToggle,
      toggled: section.getFieldValue(ADDITIONAL_RULES.FIELD_NAME.KEYS),
      disabled: section.isFieldDisabled(ADDITIONAL_RULES.FIELD_NAME.KEYS),
    },
    {
      text: 'Custom (Write my own)',
      onClick: onCustomToggle,
      toggled: section.getFieldValue(ADDITIONAL_RULES.FIELD_NAME.CUSTOM),
      disabled: section.isFieldDisabled(ADDITIONAL_RULES.FIELD_NAME.CUSTOM),
    },
  ];

  return (
    <SwitchesWithTitle
      title="Additional rules"
      legend="Which rules would you like to include?"
      switches={rules}
      noBottomMargin
      optional
    />
  );
}
